import isObject from "lodash-es/isObject";

import type { GradientStop } from "schemas/styleAttribute";

export interface Gradient {
  tilt: string;
  stops: GradientStop[];
}

export type SolidValue = { type: "solid"; color?: string | null };
export type GradientValue = { type: "gradient"; gradient: Gradient };
export type SolidOrGradient = SolidValue | GradientValue;

// Note (Chance 2023-07-14) Gradients must have at least 1 stop
export type GradientStops = [GradientStop, ...GradientStop[]];

export const isSolidValue = (value: SolidOrGradient): value is SolidValue => {
  return value.type === "solid" && value.color !== null;
};

export const isGradient = (value: unknown): value is Gradient => {
  return (
    isObject(value) &&
    value.hasOwnProperty("tilt") &&
    value.hasOwnProperty("stops")
  );
};
